
import { MOCK_LOANS, MOCK_PROPERTIES, MOCK_USER } from './shared.mock';

function buildContactInfo(loanNumber: string, property: { address: string; city: string; state: string; zip: string }) {
  return {
    loanNumber,
    emailAddress: MOCK_USER.email,
    telecomInfo: [
      {
        telecomNumber: '5551234567',
        consentRevocationFlag: false,
        type: 'Cell' as const,
        isPrimary: true,
        isDeleted: false,
      },
      {
        telecomNumber: '5559876543',
        consentRevocationFlag: false,
        type: 'Home' as const,
        isPrimary: false,
        isDeleted: false,
      },
      {
        telecomNumber: '',
        consentRevocationFlag: false,
        type: 'Work' as const,
        isPrimary: false,
        isDeleted: false,
      },
    ],
    mailingAddress: {
      street: property.address,
      addressLine2: '',
      cityName: property.city,
      stateAbbreviation: property.state,
      postalCode: property.zip,
    },
    optInOut: 'Email',
    borrowerType: 'Borrower',
    otherBorrowerTelecomDetails: [],
  };
}

export const contactInfoMock = {
  'complete-info': [
    buildContactInfo(MOCK_LOANS.mortgage.loanNumber, MOCK_PROPERTIES.mortgage),
    buildContactInfo(MOCK_LOANS.heloc.loanNumber, MOCK_PROPERTIES.heloc),
    buildContactInfo(MOCK_LOANS.homeEquity.loanNumber, MOCK_PROPERTIES.homeEquity),
  ],

  'single-loan': [buildContactInfo(MOCK_LOANS.mortgage.loanNumber, MOCK_PROPERTIES.mortgage)],

  'missing-phone': [
    {
      loanNumber: MOCK_LOANS.mortgage.loanNumber,
      emailAddress: MOCK_USER.email,
      telecomInfo: [],
      mailingAddress: {
        street: MOCK_PROPERTIES.mortgage.address,
        addressLine2: '',
        cityName: MOCK_PROPERTIES.mortgage.city,
        stateAbbreviation: MOCK_PROPERTIES.mortgage.state,
        postalCode: MOCK_PROPERTIES.mortgage.zip,
      },
      optInOut: 'Email',
      borrowerType: 'Borrower',
      otherBorrowerTelecomDetails: [],
    },
  ],

  'missing-email': [
    {
      loanNumber: MOCK_LOANS.mortgage.loanNumber,
      emailAddress: '',
      telecomInfo: [
        {
          telecomNumber: '5551234567',
          consentRevocationFlag: false,
          type: 'Cell' as const,
          isPrimary: true,
          isDeleted: false,
        },
      ],
      mailingAddress: {
        street: MOCK_PROPERTIES.mortgage.address,
        addressLine2: '',
        cityName: MOCK_PROPERTIES.mortgage.city,
        stateAbbreviation: MOCK_PROPERTIES.mortgage.state,
        postalCode: MOCK_PROPERTIES.mortgage.zip,
      },
      optInOut: 'Phone',
      borrowerType: 'Borrower',
      otherBorrowerTelecomDetails: [],
    },
  ],

  'different-mailing': [
    {
      loanNumber: MOCK_LOANS.mortgage.loanNumber,
      emailAddress: MOCK_USER.email,
      telecomInfo: [
        {
          telecomNumber: '5551234567',
          consentRevocationFlag: false,
          type: 'Cell' as const,
          isPrimary: true,
          isDeleted: false,
        },
      ],
      mailingAddress: {
        street: '999 Mailing Lane',
        addressLine2: 'Suite 100',
        cityName: 'Different City',
        stateAbbreviation: 'NY',
        postalCode: '10001',
      },
      optInOut: 'Email',
      borrowerType: 'Borrower',
      otherBorrowerTelecomDetails: [],
    },
  ],

  'needs-update': [
    {
      loanNumber: MOCK_LOANS.mortgage.loanNumber,
      emailAddress: 'old.email@example.com',
      telecomInfo: [
        {
          telecomNumber: '5550000000',
          consentRevocationFlag: false,
          type: 'Home' as const,
          isPrimary: true,
          isDeleted: false,
        },
      ],
      mailingAddress: {
        street: '123 Old Address',
        addressLine2: '',
        cityName: 'Old City',
        stateAbbreviation: 'CA',
        postalCode: '90000',
      },
      optInOut: 'Mail',
      borrowerType: 'Borrower',
      otherBorrowerTelecomDetails: [],
    },
  ],
};

export const updateContactInfoMock = {
  success: {
    isSuccess: true,
    message: 'Contact information updated successfully.',
  },
  'email-in-use': {
    isSuccess: false,
    message: 'This email address is already associated with another account.',
  },
  'invalid-phone': {
    isSuccess: false,
    message: 'Please enter a valid phone number.',
  },
  'invalid-address': {
    isSuccess: false,
    message: 'Unable to verify address. Please check and try again.',
  },
  error: {
    isSuccess: false,
    message: 'Failed to update contact information. Please try again.',
  },
};
